export enum OrderPayoutTypeEnum {
  Cash = 1,
  NonCash = 2,
}
